/* eslint-disable */
import app_header from '../components/header/index.vue';
import appFooter from '../components/footer/index';
export default {
  name: 'app',
  components: {
    'app-header': app_header,
    'app-footer': appFooter,
  },
  props: [],
  data () {
    return {
       
    }
  },
  computed: {

  }, 
  methods: {

  },
}
